import { Grid, Link, Typography } from '@mui/material';
import { SubmitButton, ToolbarButton } from '@tassat/button';
import { convertToNumber } from '@tassat/utility';
import React from 'react';

import { bodyStyles, headerStyles, screenStyles } from './styles';
import { NotificationScreenProps } from './types';
import HeaderLogos from '../HeaderLogos';

const HeaderLogosComponent: React.FC<NotificationScreenProps> = (props) => {
    const {
        clientLogoUrl,
        components,
        headerLogoHeight,
        logout
    } = props;

    const classes = headerStyles(props);

    if (clientLogoUrl) {
        return (
            <Grid
                alignItems='center'
                className={classes.logoContainer}
                container
                direction='row'
            >
                <HeaderLogos
                    clientLogoUrl={clientLogoUrl}
                    logoHeight={headerLogoHeight}
                />
                {logout && (
                    <ToolbarButton
                        className={classes.logout}
                        onClick={() => logout()}
                        text='LOG OUT'
                    />
                )}
            </Grid>
        );
    }

    if (components?.HeaderComponent) {
        const Component = components.HeaderComponent;

        return (
            <>
                <Component />
                {logout && (
                    <ToolbarButton
                        className={classes.logout}
                        onClick={() => logout()}
                        text='LOG OUT'
                    />
                )}
            </>
        );
    }

    return <></>;
};

const NotificationBodyComponent: React.FC<NotificationScreenProps> = (props) => {
    const { children } = props;
    const classes = bodyStyles(props);

    if (props.type === 'prop') {
        const {
            messages,
            supportEmail,
            supportPhone,
            title
        } = props;

        return (
            <Grid
                className={classes.bodyContainer}
                container
                direction='column'
            >
                <Typography
                    className={classes.pageTitle}
                    data-testid='NotificationScreen-title'
                    variant='h1'
                >
                    {title}
                </Typography>
                <Grid
                    className={classes.messageContainer}
                    container
                    direction='column'
                >
                    {messages.map((message, i) => (
                        <Typography
                            className={classes.messageText}
                            data-testid={`NotificationScreen-message-${i}`}
                            key={message}
                            variant='body1'
                        >
                            {message}
                        </Typography>
                    ))}
                    <SubmitButton
                        className={classes.supportButton}
                        onClick={() => window.open(`mailto:${supportEmail}`)}
                        text={supportEmail}
                        type='submit'
                    />
                    <SubmitButton
                        className={classes.supportButton}
                        onClick={() => window.open(`tel:${convertToNumber(supportPhone)}`)}
                        text={`Call Support: ${supportPhone}`}
                        type='submit'
                    />
                </Grid>
            </Grid>
        );
    }

    if (props.type === 'children') {
        return (
            <Grid
                className={classes.bodyContainer}
                container
                direction='column'
            >
                {children}
            </Grid>
        );
    }

    return <></>;
};

export const NotificationScreen: React.FC<NotificationScreenProps> = (props) => {
    const { subtitle } = props;

    const classes = screenStyles(props);

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
        >
            <Grid
                alignItems='center'
                className={classes.headerContainer}
                container
                direction='row'
            >
                <HeaderLogosComponent {...props} />
            </Grid>
            <Grid
                className={classes.bodyContainer}
                container
                direction='row'
            >
                <Grid
                    container
                    direction='column'
                    item
                    xs={6}
                >
                    <NotificationBodyComponent {...props} />
                </Grid>
                <Grid
                    alignItems='flex-end'
                    className={classes.subtitleContainer}
                    container
                    direction='column'
                    item
                    justifyContent='center'
                    xs={6}
                >
                    <Typography
                        className={classes.subtitleText}
                        data-testid='NotificationScreen-subtitle'
                        variant='h2'
                    >
                        {subtitle}
                    </Typography>
                </Grid>
            </Grid>
            <Grid
                alignItems='center'
                className={classes.footerContainer}
                container
                justifyContent='flex-end'
            >
                <Grid
                    className={classes.footerLogoContainer}
                    item
                >
                    <Link
                        className={classes.footerLink}
                        data-testid='NotificationScreen-footerLink'
                        href='https://tassat.com'
                        target='_blank'
                    >
                        <Grid
                            alignItems='center'
                            container
                            direction='row'
                        >
                            <Typography
                                className={classes.footerPOweredByText}
                                variant='body2'
                            >
                                Powered by
                            </Typography>
                            <img
                                className={classes.footerTassatLogo}
                                src='https://storage.googleapis.com/tassatpay-svgs/tas/svgs/TassatPayLogo.svg'
                            />
                        </Grid>
                    </Link>
                </Grid>
            </Grid>
        </Grid>
    );
};